export const checkPermission = (routeRole, userRole, roleAccess, userRolesAccess) => {
  if (!routeRole || !routeRole) {
    return true;
  }

  if (userRole && Array.isArray(userRole) && !Array.isArray(routeRole)) {
    return userRole.indexOf(routeRole) >= 0;
  }
  if (routeRole.length === 0) {
    return !userRole || userRole.length === 0;
  }
  if (userRole && Array.isArray(userRole) && Array.isArray(routeRole) && roleAccess.length == 0) {
    return routeRole.some((r) => userRole.indexOf(r) >= 0) 
  }
  if (userRole && Array.isArray(userRole) && Array.isArray(routeRole) && Array.isArray(roleAccess) && Array.isArray(userRolesAccess)) {
    return routeRole.some((r) => userRole.indexOf(r) >= 0) && roleAccess.some((r) => userRolesAccess.indexOf(r) >= 0)
  }
  return routeRole.indexOf(userRole) >= 0;
};

/**
 * routeRole: param for allowed role to access route
 * userRole: param for role that user authenticated has
 * roleAccess: param for role that allowed to access the route
 * userRoleAccess: param for role access that user logged in has 
 * 
 * example role: 'pegawai' | 'admin' 
 * example role access: 'CALENDAR.USER' | 'MP.USER' | 'MP.PENILAIAN' *from API
 */